/**
 * @since 2026-04-20
 * @author Francesco Parrella
 * @maintainer Francesco Parrella
 * @copyright AlgoTraders, All rights reserved
 */

import { useEffect, useState } from "react";
import { getConfig } from "../getConfig";

export const useUserRole = (idToken) => {
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      if (!idToken) {
        setUserRole(null);
        setLoading(false);
        return;
      }
      try {
        const { BACKEND_URL } = getConfig();
        const response = await fetch(`${BACKEND_URL}/api/verifyToken/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${idToken}`,
          },
          credentials: "include",
        });
        if (cancelled) return;
        if (response.ok) {
          const userData = await response.json();
          setUserRole(userData.role || null);
        } else {
          setUserRole(null);
        }
      } catch {
        if (!cancelled) setUserRole(null);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    run();
    return () => { cancelled = true; };
  }, [idToken]);

  return { userRole, loading };
};
